import { render } from "./InfoAlert.vue?vue&type=template&id=81b1e702&ts=true"
import script from "./InfoAlert.vue?vue&type=script&lang=ts"
export * from "./InfoAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__